export default __webpack_public_path__ + "static/media/unknowncard.4a18b846.svg";